import { type MinimumAddress, type SavedCustomerAddress } from '../../locations.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Compares Radar address to Gravy address to check if they're the same
 *
 * @param savedAddress - Customer address saved in Gravy
 * @param selectedAddress - Minimum address details required
 * @returns boolean
 */
export const checkIfSameAddress = (
  savedAddress: SavedCustomerAddress,
  selectedAddress: MinimumAddress,
) => {
  return (
    selectedAddress.street === savedAddress.street &&
    selectedAddress.city === savedAddress.city &&
    selectedAddress.state === savedAddress.state
  );
};
